import { useEffect } from 'react';
import ReactGA from 'react-ga4';
import { LOCAL_STORAGE_ANALYTICS_COOKIES_KEY } from '../../components/cookies/cookies';
var TRACKING_ID = 'G-N0XGQ7HG9S';
export function useGoogleAnalytics() {
    useEffect(function () {
        var hasAcceptedAnalyticsCookies = localStorage.getItem(LOCAL_STORAGE_ANALYTICS_COOKIES_KEY);
        if (hasAcceptedAnalyticsCookies && !ReactGA.isInitialized) {
            init();
        }
    }, []);
    function init() {
        var isDev = process.env.REACT_APP_ENV !== 'live';
        ReactGA.initialize(TRACKING_ID, { testMode: isDev });
    }
    function sendEvent(payload) {
        ReactGA.event(payload);
    }
    function sendPageview(path) {
        var hasAcceptedAnalyticsCookies = localStorage.getItem(LOCAL_STORAGE_ANALYTICS_COOKIES_KEY);
        if (!hasAcceptedAnalyticsCookies)
            return;
        ReactGA.set({ page: path });
        ReactGA.send({ hitType: 'pageview', page: path, title: path });
    }
    return { sendEvent: sendEvent, sendPageview: sendPageview, init: init };
}
